import config from '../../config.json';
import { withIronSession } from "next-iron-session";
import Container from "../../components/container";
import Cart from '../../components/carrito';
import CartEmpty from "../../components/cart-empty";
import axios from 'axios';
import fetch from "isomorphic-fetch";
import Whatsapp from "../../components/whatsapp";
import CartNoTown from '../../components/cart-no-town';

const Compra = ({cart, menu, coupon, noTown=false})=>{
    const validCart = ()=>{
        if(cart?.products?.length){
            return <Cart data={cart} coupon={coupon}/>
        }else if(noTown){
            return <CartNoTown />
        }else{
            return <CartEmpty />
        }
    };
    return <>
        <Container title="Carrrito de compra, Floreria Detalles y Caprichos" noNewsletter={true} menu={menu} hiddenMobile={true}>
            { validCart() }
        </Container>
        <Whatsapp/>
    </>
};

export const getServerSideProps = withIronSession(
    async ({ req, res }) => {
        const cart = await req.session.get("cart");
        const delivery = await req.session.get("delivery");
        const coupon = await req.session.get("coupon");
        const resMenu = await fetch(`${config.api.uri}/v1/cat/menu/1?apikey=${config.api.apikey}`);
        const resJSONMenu = await resMenu.json();
        if(cart?.products?.length && delivery?.town?.town?.id){
            const protocol = (config.cookie.secure) ? 'https' : 'http';
            const response = await axios({
                url:`${protocol}://${req['headers'].host}/api/get-cart`,
                method: 'POST',
                data: {
                    products: cart.products,
                    townid: delivery.town.town.id,
                    vip: !!(delivery?.delivery?.vip?.label),
                    coupon: (coupon?.code) ? coupon.code : null,
                }
            });
            return {
                props: {
                    coupon: (coupon) ? coupon : null,
                    cart: response.data,
                    menu: resJSONMenu
                }
            }
        }else{
            if(cart?.products?.length){
                return {
                    props: {
                        cart: {},
                        menu: resJSONMenu,
                        noTown: true
                    }
                }
            }else{
                return {
                    props: {
                        cart: {},
                        menu: resJSONMenu
                    }
                }
            }
        }
    },
    {
        password: config.cookie.signature,
        cookieName: config.cookie.name,
        cookieOptions: {
            secure: config.cookie.secure
        }
    }
);


export default Compra;